import { render } from "./Users-page.vue?vue&type=template&id=46b58356"
import script from "./Users-page.vue?vue&type=script&lang=js"
export * from "./Users-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__